/**
 * ANInjector queue.
 * 
 * @param {Array} queue 
 * @param {number} processQueueTimeout 
 * @param {AdsNinjaLogger} logger 
 */
function ANInjectorQueue(queue = [], processQueueTimeout = 0, logger = null){

    this.__queue               = queue || [];
    this.__processQueueTimeout = processQueueTimeout;
    this.__logger              = logger || new AdsNinjaLogger();
    this.__maxItems            = 1;
    this.__locked              = false;
    this.length                = this.__queue.length;

    this.__processQueue();
}

/**
 * Push closure to queue.
 * 
 * @param {Function} closure 
 * @returns {number}
 */
ANInjectorQueue.prototype.push = function(closure){

    if(null !== this.__maxItems && this.__maxItems > 0 && this.__queue.length < this.__maxItems){

        this.__queue.push(closure);
        this.__processQueue();
    }

    this.length = this.__queue.length;

    return this.length;
};

/**
 * Unshift closure to queue.
 * 
 * @param {Function} closure 
 * @returns {number}
 */
ANInjectorQueue.prototype.unshift = function(closure){

    if(null !== this.__maxItems && this.__maxItems > 0 && this.__queue.length < this.__maxItems){

        this.__queue.unshift(closure);
        this.__processQueue();
    }

    this.length = this.__queue.length;

    return this.length;
};

/**
 * Unlock queue processing.
 * 
 * @param {number} timeout
 */
ANInjectorQueue.prototype.__unlockProcessing = function(timeout = 0){
    
    if(timeout > 0){

        setTimeout(this.__unlockProcessing.bind(this), timeout);
        return;
    }
    
    this.__locked = false;

    this.__processQueue();
};

/**
 * Process queue.
 */
ANInjectorQueue.prototype.__processQueue = function(){
    
    if(this.__locked || this.__queue.length === 0){

        return;
    }

    this.__locked = true;

    while(this.__queue.length > 0){

        var closure = this.__queue.shift();

        try{

            closure();
        }
        catch(error){

            this.__logger.error('Error encountered while processing queue.', {
                message: error.message,
                closure: closure,
            });
        }
    }

    this.length = this.__queue.length;

    this.__unlockProcessing(this.__processQueueTimeout);
};

window.ANInjectorQueue = ANInjectorQueue;